import React from 'react';
import { Helmet } from 'react-helmet';

import BookingTrigger from '../../components/navigation/BookingTrigger';
import HeroSection from './components/HeroSection';
import ServiceHighlights from './components/ServiceHighlights';
import PopularRoutes from './components/PopularRoutes';
import QuickActions from './components/QuickActions';
import Image from '../../components/AppImage';
import { useLanguage } from '../../contexts/LanguageContext';

const HomeLanding = () => {
  const { currentLanguage, t } = useLanguage();

  const pageTitle = {
    en: "Phangan Taxi - Reliable Island Transportation Service",
    ru: "Phangan Taxi - Надежная Служба Такси на Острове",
    th: "Phangan Taxi - บริการแท็กซี่ที่เชื่อถือได้บนเกาะ",
    de: "Phangan Taxi - Zuverlässiger Inseltransportdienst",
    fr: "Phangan Taxi - Service de Transport Fiable sur l\'Île",
    zh: "帕岸出租车 - 可靠的岛屿交通服务",
    es: "Phangan Taxi - Servicio de Transporte Confiable en la Isla",
    it: "Phangan Taxi - Servizio di Trasporto Affidabile sull\'Isola",
    nl: "Phangan Taxi - Betrouwbare Eiland Transportdienst",
    he: "Phangan Taxi - שירות הסעות אמין באי"
  };

  const pageDescription = {
    en: "Book your taxi across Koh Phangan with fixed prices, 24/7 availability, and multi-language support. Instant booking via WhatsApp, Telegram, or phone.",
    ru: "Забронируйте такси на Ко Пангане с фиксированными ценами, круглосуточной доступностью и многоязычной поддержкой. Мгновенное бронирование через WhatsApp, Telegram или телефон.",
    th: "จองแท็กซี่ทั่วเกาะพะงันด้วยราคาคงที่ บริการตลอด 24 ชั่วโมง และรองรับหลายภาษา จองทันทีผ่าน WhatsApp, Telegram หรือโทรศัพท์",
    de: "Buchen Sie Ihr Taxi auf Koh Phangan mit Festpreisen, 24/7-Verfügbarkeit und mehrsprachiger Unterstützung. Sofortige Buchung über WhatsApp, Telegram oder Telefon.",
    fr: "Réservez votre taxi à Koh Phangan avec des prix fixes, une disponibilité 24h/24 et 7j/7 et un support multilingue. Réservation instantanée via WhatsApp, Telegram ou téléphone.",
    zh: "在帕岸岛预订出租车，固定价格，全天候可用，多语言支持。通过WhatsApp、Telegram或电话即时预订。",
    es: "Reserve su taxi en Koh Phangan con precios fijos, disponibilidad 24/7 y soporte multilingüe. Reserva instantánea por WhatsApp, Telegram o teléfono.",
    it: "Prenota il tuo taxi a Koh Phangan con prezzi fissi, disponibilità 24 ore su 24, 7 giorni su 7 e supporto multilingue. Prenotazione istantanea via WhatsApp, Telegram o telefono.",
    nl: "Boek uw taxi op Koh Phangan met vaste prijzen, 24/7 beschikbaarheid en meertalige ondersteuning. Directe boeking via WhatsApp, Telegram of telefoon.",
    he: "הזמן מונית בקוה פנגן במחירים קבועים, זמינות 24/7 ותמיכה בריבוי שפות. הזמנה מיידית דרך WhatsApp, Telegram או טלפון."
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle?.[currentLanguage] || pageTitle?.en}</title>
        <meta name="description" content={pageDescription?.[currentLanguage] || pageDescription?.en} />
        <meta name="keywords" content="Phangan taxi, Koh Phangan transport, island taxi service, Thailand taxi booking" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="relative">
          <div className="fixed inset-0 z-0">
            <Image
              src="https://images.unsplash.com/photo-1683512720891-41fbf91637eb"
              alt="Scenic coastal road on Koh Phangan island with turquoise ocean waters, lush green palm trees, and winding asphalt path under clear blue tropical sky"
              className="w-full h-full object-cover" />
          </div>

          <div className="relative z-10">
            <HeroSection />
          </div>
        </div>

        <ServiceHighlights currentLanguage={currentLanguage} />
        <PopularRoutes currentLanguage={currentLanguage} />
        <QuickActions currentLanguage={currentLanguage} />

        <BookingTrigger isFab />
      </div>
    </>
  );
};

export default HomeLanding;